var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"slug":"design","icon":"icons","name":"设计资源","hasRight":false},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('Nav')]},proxy:true}])},[_c('div',{staticClass:"m-archive-box"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }